<template>
  <div v-if="router.currentRoute.value.name != 'home'" class="bodys">
    <div  v-if="ispc" :class="router.currentRoute.value.name == '项目展示'?'':'flex flex-col-center flex-row-between'" class=" navsers " >
      <div class="flex flex-col-center">
        <img class="navsers_icons" src="@/assets/homes.png" alt="" srcset="">
        <div class="navsers_l_texts navsers_ls spacing">您的位置：</div>
        <div @click="pageChange('/')" class="navsers_l_texts cur_po spacing">首页</div>
        <el-icon><ArrowRightBold /></el-icon>
        <div class="navsers_l_texts spacing">
          {{ router.currentRoute.value.meta.title }}
        </div>
        <el-icon v-if="router.currentRoute.value.query.pid"><ArrowRightBold /></el-icon>
        <div  @click="pagefenlei" v-if="router.currentRoute.value.query.pid" class="navsers_l_texts spacing">
          {{ setlists(router.currentRoute.value.query.pid)}}
        </div>
      </div>
      <div v-if="!router.currentRoute.value.meta.hidens"  :class="router.currentRoute.value.name == '项目展示'?'flex-row-center xiangmulist':'flex-1 flex-row-right'" class=" flex-wrap flex flex-col-center " >
        <div
          @click="pageChangebtns(routers.paths, item)"
          class="navsers_items spacing"
          :class="{
            navsers_items_checks:
              (item.id && item.id == router.currentRoute.value.query.ids) ||
              (item.paths && item.name == router.currentRoute.value.name),
          }"
          v-for="(item, index) in setlists()"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div  v-if="router.currentRoute.value.name == '搜索'" class="searchs_righs bg_F8F8F8 flex flex-col-center" >
        <el-icon color="#999" size="16"><Search /></el-icon>
        <input
          v-model="searchNames"
          class="searchs_righs_inputs spacing"
          type="text"
          placeholder="请输入项目名称"
        />
        <div @click="tosearchse" class="searchs_righs_btns cur_po spacing">搜索</div>
      </div>
    </div>
    <div v-else class="navsers ">
      <div v-if="router.currentRoute.value.name == '新闻中心'"  class=" flex-wrap flex flex-row-center" >
        <div
          @click="pageChangebtns(routers.paths, item)"
          class="navsers_items"
          :class="{
            navsers_items_checks:item.id && item.id == router.currentRoute.value.query.ids
          }"
          v-for="(item, index) in setlists()"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>

      <div  v-if="router.currentRoute.value.name == '搜索'" class="searchs_righs bg_F8F8F8 flex flex-col-center" >
        <el-icon color="#999" size="40rem"><Search /></el-icon>
        <input
          v-model="searchNames"
          class="searchs_righs_inputs"
          type="text"
          placeholder="请输入项目名称"
        />
        <div @click="tosearchse" class="searchs_righs_btns cur_po">搜索</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch, computed, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const routers = ref({});
const searchNames = ref(store.state.searchNames);
const ispc = computed(() => store.state.ispc);
watch(
  () => store.state.searchNames,
  () => {
    searchNames.value = store.state.searchNames;
  }
);

const tosearchse = () => {
  store.commit("setsearchNames", searchNames.value);
};

const setlists = (ids) => {
  var lists = [];
  store.state.routes.forEach((items) => {
    if (items.keys == router.currentRoute.value.meta.keys && items.chirchens) {
      routers.value = items;
      lists = items.chirchens;
    }
  });
  if(ids){
    var names=""
    lists.forEach(items=>{
      if(items.id==ids){
        names=items.name
      }
    })
    return names;
  }else{
    return lists;
  }
};

const pageChangebtns = (paths, items) => {
  if (items.paths) {
    pageChange(paths + "/" + items.paths);
  } else {
    pageChange(paths + "?ids=" + items.id);
  }
};

const pagefenlei=()=>{
  if(router.currentRoute.value.meta.title=='项目展示'){
    pageChange("/projecse?ids=" + router.currentRoute.value.query.pid);
  }else{
    pageChange("/news?ids=" + router.currentRoute.value.query.pid);
  }
}

const pageChange = (urls) => {
  window.scrollTo(0, 0);
  router.push(urls);
};
</script>

<style>
@media screen and (max-width: 768px) {
  .navsers {
    padding: 18rem 0;
  }
  .searchs_righs{
    margin: 6rem 0;
    background: #F8F8F8;
    border-radius: 40rem;
    padding: 10rem 25rem;
  }
  .searchs_righs_inputs{
    font-size: 28rem;
    flex: 1;
    padding: 0 15rem;
  }
  .searchs_righs_btns{
    width: 100rem;
    height: 55rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #085688;
    border-radius: 30rem;
    color: #ffffff;
    font-size: 30rem;
  }

  
  .navsers_items {
    height: 45rem;
    line-height: 45rem;
    padding: 0 16rem;
    font-size: 24rem;
    border-radius: 30rem;
    background: #DFDFDF;
    margin: 10rem 15rem;
  }
  .navsers_items_checks {
    background: #075785;
    color: #ffffff;
  }
}
@media screen and (min-width: 768px) {
  .searchs_righs {
    padding: 0 0 0 10px;
  }
  .searchs_righs_inputs {
    width: 200px;
  }
  .searchs_righs_btns {
    width: 55px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #085688;
    font-size: 14px;
    color: #ffffff;
  }

  .navsers {
    padding: 25px 0 30px;
  }
  .navsers_icons{
    width: 16px;
  }
  .navsers_ls {
    margin-left: 15px;
  }
  .navsers_l_texts {
    font-size: 16px;
    color: #333333;
  }
  .navsers_items {
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 16px;
    margin: 0 0 0 15px;
    border-radius: 30px;
    cursor: pointer;
  }
  .navsers_items:hover,
  .navsers_items_checks {
    background: #075785;
    color: #ffffff;
  }
  .xiangmulist{
    margin-top: 10px;
  }
}
@media screen and (min-width: 768px) and (max-width: 900px) {
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
}
@media screen and (min-width: 1200px) and (max-width: 1400px) {
}
@media screen and (min-width: 1400px) and (max-width: 1700px) {
}
@media screen and (min-width: 1700px) {
}
</style>
